(() => {
  const sections = ["main-cart-items", "cart-live-region-text", "cart-footer"];
  const cartUpdate = async () => {
    const timeEl = document.getElementById("haisoShippingtime");
    const dateEl = document.getElementById("haisoShippingdate");
    const attrs = {};
    if (timeEl) attrs["delivery_time"] = timeEl.value || "";
    if (dateEl) attrs["delivery_date"] = dateEl.value || "";

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attrs }),
    });
    if (!res.ok) throw new Error("cart update failed");

    // Dawnのセクション差し替え
    const htmlRes = await fetch(`${location.pathname}?sections=${sections.join(",")}`);
    const html = await htmlRes.json();
    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el && html[id]) el.innerHTML = html[id];
    });
  };

  // アプリのハンドラより先に握る（競合回避）
  const handler = async (e) => {
    const id = e.target?.id;
    if (id !== "haisoShippingtime" && id !== "haisoShippingdate") return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    try {
      await cartUpdate();
    } catch (err) {
      location.reload();
    }
  };

  // captureで先取り
  document.addEventListener("change", handler, true);

  // 念のため：カートフォームの関連付け（フォーム外に描画されるケース）
  window.addEventListener("DOMContentLoaded", () => {
    ["haisoShippingtime", "haisoShippingdate"].forEach((id) => {
      const el = document.getElementById(id);
      if (el && !el.getAttribute("form")) el.setAttribute("form", "cart");
    });
  });
})();
